import { Component, OnInit, ViewChild } from '@angular/core';
import { AdminSchoolListComponent } from '../admin-school-list/admin-school-list.component';
import { CookieService } from 'ngx-cookie-service';
import { SchoolAdminService } from '../../../core/school-admin.service';

@Component({
  selector: 'app-admin-school-approved-list',
  templateUrl: './admin-school-approved-list.component.html',
  styleUrls: ['./admin-school-approved-list.component.css']
})
export class AdminSchoolApprovedListComponent extends AdminSchoolListComponent implements OnInit {

  status = 'approved';

  constructor(
    cookieService: CookieService,
    schoolAdminService: SchoolAdminService
  ) {
    super(cookieService, schoolAdminService);
  }

}
